// ABOUTME: Initializes tokenize tag input on connect.
// ABOUTME: Replaces SJR-based MediaAssetAction().bindTagInputs() reinitialization.

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    var inputSelector = $(this.element).find('.tagsinput')
    var overlaySelector = $(this.element).find('.tagsinput-overlay')
    if (inputSelector.length) {
      new MediaAssetAction().bindTagInputs(inputSelector, overlaySelector)
    }
  }
}
